import Shader from "_src/engine/shader";
import Uniform from "_src/engine/uniform";
import { vec4 } from "_src/libs/gl-matrix";
import { uniformType, uniformSource } from "_src/engine/constants";

import vertText from "_src/shaders/screen/screen.glslv";
import fragText from "_src/shaders/screen/screen.glslf";

export default class ScreenShader extends Shader {

  constructor(params = {}) {

    super(params);

    this.attachUniforms(params);

  }

  compile() {
    super.compile(vertText, fragText);
  }

  attachUniforms() {

    const diffuseColor = vec4.fromValues(0.8, 0.8, 0.8);
    this.uniforms["u_diffuse"] = new Uniform(uniformType.FLOAT4V, diffuseColor, uniformSource.OBJECT);

  }

  updateObjectUniformValues(object) {
    vec4.copy(this.uniforms["u_diffuse"].value, object.properties.diffuseColor);
  }

}
